import CheckForSave from "./CheckForSave";

export default function(state, payload){
  const {value, campaignID} = payload;
  const { campaigns } = state;
  let campaign = campaigns.index[campaignID]
  campaign.title = value
  state.campaigns.index[campaignID] = campaign
  return CheckForSave({...state})
}